export interface ObjectError {
	get message(): string
}

export interface FieldError extends ObjectError {
	get field(): string
}

export interface Errors {
	hasFieldErrors(field: string): boolean

	getFieldErrors(field: string): FieldError[]

	getObjectErrors(): ObjectError[]

	changeMapKeysToPath(prefix: string): void
}

export function emptyErrors(): Errors {
	return {
		getFieldErrors() {
			return [];
		},
		getObjectErrors(): FieldError[] {
			return [];
		},
		hasFieldErrors(field: string): boolean {
			return false;
		},
		changeMapKeysToPath() {
		}
	}
}

export function adaptErrors(errorsOrJson?: any): Errors {
	if (errorsOrJson === null || errorsOrJson === undefined) {
		return emptyErrors();
	}
	if ('getObjectErrors' in errorsOrJson && typeof errorsOrJson['getObjectErrors'] === 'function') {
		return errorsOrJson
	}

	const fieldErrors: FieldError[] = Object.entries(errorsOrJson["fieldErrors"] || {})
		.flatMap(e => (e[1] as []).map(error => ({
			get field(): string {
				return `${e[0]}`;
			},
			get message(): string {
				return `${error}`;
			}
		})));
	const objectErrors: ObjectError[] = (errorsOrJson["objectErrors"] || [])
		.map((e: any) => ({
			get message(): string {
				return `${e}`;
			}
		}));

	return {
		hasFieldErrors(field: string): boolean {
			return fieldErrors.some(e => e.field === field);
		},
		getObjectErrors(): ObjectError[] {
			return objectErrors;
		},
		getFieldErrors(field: string): FieldError[] {
			return fieldErrors.filter(e => e.field === field);
		},
		changeMapKeysToPath(prefix: string) {
			for (let i = 0; i < fieldErrors.length; ++i) {
				const f = fieldErrors[i];
				const field = f.field;
				if (!field.startsWith(prefix)) continue

				const suffix = field.substring(prefix.length);
				const newSuffix = suffix.replace(/\[(.+?)]/g, m => {
					const key = /\[(.+)]/g.exec(m)!![1]
					return `.${key}`;
				})

				fieldErrors[i] = {
					get field(): string {
						return `${prefix}${newSuffix}`;
					},
					get message(): string {
						return f.message;
					}
				}
			}
			for (const f of fieldErrors) {
			}
		}
	};
}